import React from "react"
import { graphql } from "gatsby"
import { Box, Container } from "@theme-ui/components"
import loadable from "@loadable/component"
import Layout from "../components/layout"
import { getPagePath } from "../utils/path"
import { HelmetDatoCms } from "gatsby-source-datocms"
import TitleAndBody from "../components/blocks/titleAndBody"
import PageCarousel from "../components/blocks/pageCarousel"
import Image from "../components/blocks/image"
import ImageGallery from "../components/blocks/imageGallery"
import OrderedList from "../components/blocks/orderedList"
import ItemCarousel from "../components/blocks/itemCarousel"
import Accordion from "../components/blocks/accordion"
import DocumentCollection from "../components/blocks/documentCollection"
import Embed from "../components/blocks/embed"
import PageHero from "./pageHero"
import ImageAndText from "../components/blocks/imageAndText"
import NumbersCollection from "../components/blocks/numbersCollections"
import ContactForm from "../components/blocks/contactFrom"
import PageIntro from "../components/blocks/pageIntro"
import ServiceCollection from "./serviceCollection"
import ImageTextCollection from "./imageAndTextCollection"
import ListCollection from "../components/listCollection"
import CardCollection from "../components/blocks/cardCollection"
import ProjectCardCollection from "../components/projectCardCollection"
import BigTitle from "../components/bigTitle"
import PageCardCollection from "../components/pageCardCollection"
import CtaCollection from "../components/ctaCollection"
const LocationsMap = loadable(
  () => import("../components/blocks/locationMap"),
  { ssr: false }
)

const Page = ({ data: { page, site, footer, menu, partner }, pageContext }) => {
  const locale = pageContext.locale
  console.log(page.prefooter)
  const pageAllSlugLocales = page._allSlugLocales.sort(function (a, b) {
    return site.locales.indexOf(a.locale) - site.locales.indexOf(b.locale)
  })

  const i18nPaths = pageAllSlugLocales.map(locale => {
    return {
      locale: locale.locale,
      value: getPagePath(page, locale.locale),
    }
  })
  const pageIntroBlock = page.content.find(
    block => block.model.apiKey === "page_intro"
  )
  const primaryNav = pageIntroBlock ? pageIntroBlock.variant : false

  return (
    <Layout
      background={page.background?.hex}
      partner={partner}
      locale={locale}
      i18nPaths={i18nPaths}
      menuData={menu.nodes}
      footerData={footer.nodes}
      primaryNav={primaryNav}
    >
      <HelmetDatoCms seo={page.seoMetaTags}>
        <html lang={page.locale} />
      </HelmetDatoCms>

      {page.content.map(block => (
        <Box as="section" key={block.id}>
          {block.model.apiKey === "page_hero" && (
            <PageHero block={block} media={block.video} />
          )}
          {block.model.apiKey === "big_title_and_link" && (
            <BigTitle block={block} />
          )}
          {block.model.apiKey === "page_intro" && <PageIntro block={block} />}

          {block.model.apiKey === "service_collection" && (
            <ServiceCollection block={block} />
          )}
          {block.model.apiKey === "image_text_collection" && (
            <ImageTextCollection block={block} />
          )}
          {block.model.apiKey === "list_collection" && (
            <ListCollection block={block} />
          )}
          {block.model.apiKey === "card_collection" && (
            <CardCollection block={block} />
          )}
          {block.model.apiKey === "project_card_collection" && (
            <ProjectCardCollection block={block} />
          )}
          {block.model.apiKey === "page_card_collection" && (
            <PageCardCollection block={block} />
          )}
          {block.model.apiKey === "contact_form" && (
            <ContactForm
              block={block}
              kicker={block.kicker}
              title={block.title}
              subtitle={block.subtitle}
              privacyPolicyDescription={block.privacyPolicyDescription}
              newsletterDescription={block.newsletterDescription}
            />
          )}
          {block.model.apiKey === "cta_collection" && (
            <CtaCollection block={block} />
          )}
          {block.model.apiKey === "locations_map" && (
            <LocationsMap title={block.title} locations={block.locations} />
          )}
          {/*  {block.model.apiKey === "ordered_list" && (
            <OrderedList
              title={block.title}
              subtitle={block.subtitle}
              body={block.body}
            />
          )}
          {block.model.apiKey === "page_carousel" && (
            <PageCarousel title={block.title} pages={block.pages} />
          )}
          {block.model.apiKey === "item_carousel" && (
            <ItemCarousel items={block.items} />
          )}
          {block.model.apiKey === "accordion" && (
            <Accordion title={block.title} items={block.items} />
          )}
          {block.model.apiKey === "document_collection" && (
            <DocumentCollection
              title={block.title}
              documents={block.documents}
              showPublicationDate={block.showPublicationDate}
            />
          )}
          {block.model.apiKey === "image" && <Image image={block.image} />}
          {block.model.apiKey === "locations_map" && (
            <LocationsMap locations={block.locations} />
          )}
          {block.model.apiKey === "contact_form" && (
            <ContactForm
              block={block}
              kicker={block.kicker}
              title={block.title}
              subtitle={block.subtitle}
              privacyPolicyDescription={block.privacyPolicyDescription}
              newsletterDescription={block.newsletterDescription}
            />
          )}
          {block.model.apiKey === "embed" && (
            <Embed
              title={block.title}
              code={block.code}
              fullWidth={block.fullWidth}
            />
          )}
          {block.model.apiKey === "image_gallery" && (
            <Container>
              <ImageGallery images={block.images} />
            </Container>
          )}
          {block.model.apiKey === "numbers_collection" && (
            <NumbersCollection
              title={block.title}
              image={block.image}
              numbers={block.numbers}
            />
          )}
          {block.model.apiKey === "contact_form" && (
            <ContactForm
              kicker={block.kicker}
              title={block.title}
              subtitle={block.subtitle}
              privacyPolicyDescription={block.privacyPolicyDescription}
              newsletterDescription={block.newsletterDescription}
            />
          )}

           */}
        </Box>
      ))}
    </Layout>
  )
}

export default Page

export const query = graphql`
  query PageQuery($id: String!, $locale: String!) {
    site: datoCmsSite {
      locales
    }
    footer: allDatoCmsFooter(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...FooterDetails
      }
    }

    menu: allDatoCmsMenu(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...MenuDetails
      }
    }

    partner: allDatoCmsPartner(sort: { position: ASC }) {
      ...PartnerFragment
    }

    page: datoCmsPage(id: { eq: $id }, locale: $locale) {
      ...PageDetails
      ...PageTreeParent
      ...AllSlugLocales
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      background {
        hex
      }
      prefooter
      content {
        ... on DatoCmsLocationsMap {
          id
          title
          locations {
            originalId
            id
            name
            addressCountry
            addressRegion
            addressLocality
            email
            faxNumber
            coordinates {
              latitude
              longitude
            }
            postalCode
            streetAddress
            telephone
          }
          model {
            apiKey
          }
        }
        ... on DatoCmsCtaCollection {
          id
          cta {
            title
            subtitle
            link {
              anchor
              link {
                ... on DatoCmsPage {
                  root
                  id
                  _allSlugLocales {
                    locale
                    value
                  }
                }
              }
            }
          }
          model {
            apiKey
          }
        }
        ... on DatoCmsContactForm {
          id
          kicker
          model {
            apiKey
          }
          privacyPolicyDescription
          newsletterDescription
          subtitle
          title
        }
        ... on DatoCmsBigTitleAndLink {
          id
          contact
          model {
            apiKey
          }
          title
          kicker

          link {
            anchor
            link {
              ... on DatoCmsPage {
                root
                id
                _allSlugLocales {
                  locale
                  value
                }
              }
            }
          }
        }
        ... on DatoCmsPageHero {
          id
          model {
            apiKey
          }
          kicker
          body
          title
          video {
            mimeType
            url
            video {
              thumbnailUrl
              streamingUrl
              muxPlaybackId
            }
          }
        }
        ... on DatoCmsPageIntro {
          variant
          id
          model {
            apiKey
          }
          title
          subtitle
          kicker
        }
        ... on DatoCmsServiceCollection {
          id
          kicker
          model {
            apiKey
          }
          services {
            body
            title
          }
        }
        ... on DatoCmsImageTextCollection {
          id
          model {
            apiKey
          }
          kicker
          blocks {
            title
            subtitle
            body
            accordion {
              title
              subtitle
            }
            video {
              mimeType
              url
              gatsbyImageData
              video {
                thumbnailUrl
                streamingUrl
                muxPlaybackId
              }
            }
          }
        }
        ... on DatoCmsListCollection {
          id
          title
          dark
          kicker
          model {
            apiKey
          }
          list
        }
        ... on DatoCmsCardCollection {
          id
          model {
            apiKey
          }
          cards {
            acronym
            title
            body

            link {
              anchor

              link {
                ... on DatoCmsPage {
                  id
                  _allSlugLocales {
                    locale
                    value
                  }
                  slug
                  root
                }
              }
            }
          }
        }
        ... on DatoCmsProjectCardCollection {
          id
          model {
            apiKey
          }
          projects {
            _allSlugLocales {
              value
              locale
            }
            imageThumb {
              gatsbyImageData(
                width: 720
                placeholder: BLURRED
                forceBlurhash: false
              )
            }
            image {
              gatsbyImageData
            }
            page {
              title
            }
            slug
            title
            body {
              value
            }
          }
        }
        ... on DatoCmsPageCardCollection {
          id
          model {
            apiKey
          }
          page {
            _allSlugLocales {
              value
              locale
            }
            root
            heroImage {
              video {
                duration
                frameRate
                mp4Url
                muxPlaybackId
                streamingUrl
                thumbnailUrl
              }
              customData
              url
              mimeType
            }
            slug
            title
            body {
              value
            }
          }
        }
        ... on DatoCmsBigTitleAndLink {
          id
          title
          link {
            link {
              ... on DatoCmsPage {
                id
                _allSlugLocales {
                  value
                  locale
                }
                title
                slug
              }
            }
          }
        }
      }
    }
  }

  fragment RichContent on DatoCmsRichContent {
    title
    label
    subtitle
    image {
      gatsbyImageData(width: 1480, placeholder: BLURRED, forceBlurhash: false)
    }
    body {
      blocks {
        __typename
        ... on DatoCmsImageGallery {
          id: originalId
          ...ImageGallery
        }
        ... on DatoCmsEmbed {
          id: originalId
          ...EmbedDetails
        }
        ... on DatoCmsNumbersGroup {
          id: originalId
          numbers {
            legend
            float
            suffix
            prefix
          }
        }
      }
      links {
        __typename
        ... on DatoCmsInternalLink {
          id: originalId
          anchor
          locales
          model {
            apiKey
          }
          link {
            ... on DatoCmsBlogPage {
              ...BlogDetails
            }
            ... on DatoCmsPage {
              ...PageDetails
              ...PageTreeParent
              ...AllSlugLocales
            }
            ... on DatoCmsArticle {
              ...ArticleDetails
              ...ArticleAllSlugLocales
            }
            ... on DatoCmsArticleCategory {
              ...ArticleCategoryDetails
              ...ArticleCategoryAllSlugLocales
            }
          }
        }
      }
      value
    }
    model {
      apiKey
    }
  }

  fragment AllSlugLocales on DatoCmsPage {
    _allSlugLocales {
      value
      locale
    }
  }

  fragment PageDetails on DatoCmsPage {
    id
    locales
    title
    slug
    root
    model {
      apiKey
    }
    heroImage {
      gatsbyImageData(
        width: 1920
        placeholder: NONE
        forceBlurhash: false
        imgixParams: { monochrome: "00A889" }
      )
    }
  }

  fragment EmbedDetails on DatoCmsEmbed {
    title
    code
    fullWidth
    model {
      apiKey
    }
  }

  fragment PageTreeParent on DatoCmsPage {
    treeParent {
      id
      title
      slug
      root
      locales
      ...AllSlugLocales
      treeParent {
        id
        title
        slug
        root
        locales
        ...AllSlugLocales
      }
    }
  }
`
